import { ProfileSectionHeader } from '@/components/profile/ProfileSectionHeader';
import { ProfileBodyText } from '@/components/profile/ProfileText';
import { View } from '@/components/ui/view';
import { VStack } from '@/components/ui/vstack';

interface AboutSectionProps {
  section: {
    title: string;
    data: readonly { text?: string | null }[];
  };
  isFirstSection: boolean;
  isOwnProfile?: boolean;
  onEdit?: () => void;
}

export const AboutSection = ({
  section,
  isFirstSection,
  isOwnProfile,
  onEdit,
}: AboutSectionProps) => {
  return (
    <View className={isFirstSection ? 'mt-9' : 'mt-10'}>
      <ProfileSectionHeader title={section.title} isOwnProfile={isOwnProfile} onEdit={onEdit} />
      {section.data.map((item, index) => (
        <VStack key={`about-item-${index}`} className="mx-auto w-full max-w-5xl items-start px-6">
          {item.text?.split('\n').map((line, lineIndex) => {
            if (line.trim() === '') {
              return <View key={`empty-${lineIndex}`} className="h-4" />;
            }

            return <ProfileBodyText key={`line-${lineIndex}`}>{line}</ProfileBodyText>;
          })}
        </VStack>
      ))}
    </View>
  );
};
